var lib_core = require("lib-core");
var Properties = require("cio-config").MetaProperties;
var FilterInteractionModel = require("./filterInteractionModel.js");

var TrayTabsModel = function (name, type) {
    lib_core.Model.call(this);

    var self = this;
    this.name = name; 
    this.type = this.value("dataType", null);
    this.type(type);

    this.tabs = this.list("tabs", false);
    this.activeTab = this.value("activeTab", false);
    this.templateSwitcherButton = this.value("templateSwitcherButton", true);
    this.distanceToBottom = this.value("distanceToBottom", true);
    this.almost_bottom_threshold = 50;

    this.searchVisible = this.value("searchVisible", true);
    this.searchVisible(true);
 
    this.searchFiltersEnabled = this.value("searchFiltersEnabled", true);
    this.searchFiltersEnabled(false);

    this.activeSearchFilters = this.list("activeSearchFilters", true);

    this.searchFiltersEnabled.onChange(this, function(val){
        if(val && self.activeSearchFilters.size() == 0){
            self.addActiveSearchFilter(0);
        }
        self.tabs.forEach(function(ind, tab){
            tab.reload();
        });
    });
};

lib_core.inherit(TrayTabsModel, lib_core.Model);
lib_core.JsonParser.registerClass(TrayTabsModel, "TrayTabsModel");


TrayTabsModel.prototype.createSearchFilter = function(ind) {
    return new FilterInteractionModel(ind, this.type());
}

TrayTabsModel.prototype.addActiveSearchFilter = function(ind) {
    // TODO insert at correct index in list (this requires bummping up index the same way we bump down)
    this.activeSearchFilters.push(this.createSearchFilter(this.activeSearchFilters.size()));
};

TrayTabsModel.prototype.removeActiveSearchFilter = function(index) {
    if(this.activeSearchFilters.size() > 1){
        this.activeSearchFilters.remove(index);
        this.activeSearchFilters.forEach(function(ind, val){
            if(ind >= index) val.decreaseIndex();
        })
        this.search();
    } else {
        this.activeSearchFilters.remove(index);
        this.searchFiltersEnabled(false);
    }
};

TrayTabsModel.prototype.setFilter = function(index, key, val){
    var filter = this.activeSearchFilters.get(index);

    if(key !== undefined) filter.keyShadow(key);
    if(val !== undefined) filter.valShadow(val);

    this.search();
}

TrayTabsModel.prototype.search = function(){
    console.log("searching");

    // TODO hide this behind a timer?
    // (note that the tabs already do this)

    this.tabs.forEach(function(ind, tab){
        tab.reload();
    });
}

TrayTabsModel.prototype.convertAll = function(){
    var searchable = true;
    this.activeSearchFilters.forEach(function(index, val){
        if(!val.convertAndSet()) searchable = false;
    });

    if(searchable) this.search();
}

module.exports = TrayTabsModel;


